/*
 * https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js/
 */
import { clearRefinements } from 'instantsearch.js/es/widgets'
export const siteClearRefinements = clearRefinements({
  container: '#clearRefinementList',
  cssClasses: {
    root: [
      'mt-2.5'
    ]
  },
  templates: {
    resetLabel: 'View All'
  }
})
